module.exports = __webpack_public_path__ + "static/media/tarot-card-7.66cf806b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/checkastronow/assets/images/tarotcards/tarot-card-7.jpg
// module id = 1553
// module chunks = 0